import React, { useState, useContext } from 'react'
import Sidebar from 'components/slidingpane/component'
import { RatingExplanationButton } from 'components/ratingExplanationButton/component'
import { withRail } from 'components/rail'
import { LocaleContext } from '../../contexts/locale'

const RailedButton = withRail(RatingExplanationButton)

export const WhereToWatch = () => {
  const [slidingPaneIsOpen, toggleSlidingPane] = useState(false)
  const locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  return (
    <>
      <div className='ui text container'>
        <RailedButton
          clickHandler={() => {
            toggleSlidingPane(prevState => !prevState)
          }}
          side='right'
          className='center aligned'
        />
      </div>

      <Sidebar
        isOpen={slidingPaneIsOpen}
        onRequestClose={() => toggleSlidingPane(prevState => !prevState)}
        title={messages.slider.header}
        className='infographic'
      >
        {messages.slider.content}
      </Sidebar>
    </>
  )
}
